import { IMonitoringOversightRepository } from "../repositories/MonitoringOversightRepository";
import type {
  MonitoringOversightStats,
  StudyMonitoringSummary,
  StudyMonitoringDetailsResponse,
  SiteMonitoringDetailsResponse,
} from "../types/monitoringOversight.type";
export interface IMonitoringOversightUseCase {
  getOversightStats(studyId?: string): Promise<MonitoringOversightStats>;
  getStudySummaries(): Promise<StudyMonitoringSummary[]>;
  getStudyMonitoringDetails(
    studyId: string,
  ): Promise<StudyMonitoringDetailsResponse>;
  getSiteMonitoringDetails(
    siteId: string,
  ): Promise<SiteMonitoringDetailsResponse>;
}
export class MonitoringOversightUseCase implements IMonitoringOversightUseCase {
  constructor(
    private monitoringOversightRepository: IMonitoringOversightRepository,
  ) {}
  async getOversightStats(studyId?: string): Promise<MonitoringOversightStats> {
    try {
      return await this.monitoringOversightRepository.getOversightStats(
        studyId,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Failed to fetch oversight stats",
      );
    }
  }
  async getStudySummaries(): Promise<StudyMonitoringSummary[]> {
    try {
      return await this.monitoringOversightRepository.getStudySummaries();
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Failed to fetch study summaries",
      );
    }
  }
  async getStudyMonitoringDetails(
    studyId: string,
  ): Promise<StudyMonitoringDetailsResponse> {
    try {
      if (!studyId?.trim()) {
        throw new Error("Study ID is required");
      }
      return await this.monitoringOversightRepository.getStudyMonitoringDetails(
        studyId,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Failed to fetch study monitoring details",
      );
    }
  }
  async getSiteMonitoringDetails(
    siteId: string,
  ): Promise<SiteMonitoringDetailsResponse> {
    try {
      if (!siteId?.trim()) {
        throw new Error("Site ID is required");
      }
      return await this.monitoringOversightRepository.getSiteMonitoringDetails(
        siteId,
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Failed to fetch site monitoring details",
      );
    }
  }
}
